export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5579.acf93119.jpg";